import apiConfig from "./APIConfig";

const baseURL = apiConfig.appConfig.apietmf

export default baseURL;